export default __webpack_public_path__ + "img/dlLiDVXC.0258bcaf.svg";